/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { createBrowserRouter } from "react-router-dom";
import { redirectLoader } from "./redirect-loader";
import { RouterError } from "cms/layout/error/router-error";
import { Home } from "pages/home";
import { Webpage } from "pages/webpage";
import { FormContinuePage } from "pages/form-continue/form-continue-page";

/**
 * Data enabled routes for the application.  This exists outside the app itself
 * as they only need to be rendered once.
 */
export const router = createBrowserRouter([
    {
        path: "/",
        element: <Home />,
        errorElement: <RouterError />,
    },

    // Form continue route
    {
        path: "/form/continue",
        element: <FormContinuePage />,
        errorElement: <RouterError />,
    },

    // catch all for paths of any length
    // will need to handle its own 404 logic
    {
        path: "*",
        element: <Webpage />,
        errorElement: <RouterError />,
        loader: redirectLoader,
    },
    {
        future: {
            // https://reactrouter.com/6.30.0/upgrading/future
            // https://github.com/remix-run/react-router/blob/main/CHANGELOG.md
            // v7_startTransition: true,
            // v7_fetcherPersist: true,
            // v7_normalizeFormMethod: true,
            // v7_partialHydration: true,
            // v7_relativeSplatPath: true,
            // v7_skipActionErrorRevalidation: true,
        }
    }
]);
